// Dashboard Reducer
import { createReducer, on } from '@ngrx/store';
import { DashboardState, initialDashboardState, initialDashboardFilters } from './dashboard.state';
import * as DashboardActions from './dashboard.actions';

export const dashboardReducer = createReducer(
  initialDashboardState,

  // Load Dashboard
  on(DashboardActions.loadDashboard, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DashboardActions.loadDashboardSuccess, (state, { rows, total, pageSize, page, hasMore, nextCursor }) => ({
    ...state,
    rows,
    total,
    pageSize,
    currentPage: page,
    hasMore,
    nextCursor,
    loading: false,
    error: null,
  })),
  on(DashboardActions.loadDashboardFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Refresh Dashboard
  on(DashboardActions.refreshDashboard, (state) => ({
    ...state,
    refreshing: true,
    error: null,
  })),
  on(DashboardActions.refreshDashboardSuccess, (state, { rows, total, pageSize, page, hasMore, nextCursor }) => ({
    ...state,
    rows,
    total,
    pageSize,
    currentPage: page,
    hasMore,
    nextCursor,
    refreshing: false,
    error: null,
  })),
  on(DashboardActions.refreshDashboardFailure, (state, { error }) => ({
    ...state,
    refreshing: false,
    error,
  })),

  // Load Device Types
  on(DashboardActions.loadDeviceTypesSuccess, (state, { deviceTypeMap }) => ({
    ...state,
    deviceTypeMap,
  })),

  // Pagination
  on(DashboardActions.setPage, (state, { page }) => ({
    ...state,
    currentPage: page,
  })),
  on(DashboardActions.setPageSize, (state, { pageSize }) => ({
    ...state,
    pageSize,
    currentPage: 1, // Reset to first page when page size changes
  })),
  on(DashboardActions.nextPage, (state) => ({
    ...state,
    currentPage: state.currentPage + 1,
  })),
  on(DashboardActions.previousPage, (state) => ({
    ...state,
    currentPage: Math.max(1, state.currentPage - 1),
  })),

  // Search
  on(DashboardActions.setSearchQuery, (state, { query }) => ({
    ...state,
    searchQuery: query,
  })),
  on(DashboardActions.applySearch, (state) => ({
    ...state,
    appliedQuery: state.searchQuery,
    currentPage: 1,
  })),
  on(DashboardActions.clearSearch, (state) => ({
    ...state,
    searchQuery: '',
    appliedQuery: '',
    currentPage: 1,
  })),

  // Filters
  on(DashboardActions.setFilter, (state, { key, value }) => ({
    ...state,
    filters: {
      ...state.filters,
      [key]: value,
    },
  })),
  on(DashboardActions.setFilters, (state, { filters }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...filters,
    },
  })),
  on(DashboardActions.clearFilters, (state) => ({
    ...state,
    filters: initialDashboardFilters,
  })),

  // Update filter options
  on(DashboardActions.updateFilterOptions, (state, { hubOptions, environmentOptions, deviceTypeOptions }) => ({
    ...state,
    hubOptions,
    environmentOptions,
    deviceTypeOptions,
  })),

  // Sorting
  on(DashboardActions.setSort, (state, { sortKey, sortDirection }) => ({
    ...state,
    sortKey,
    sortDirection,
  })),
  on(DashboardActions.toggleSort, (state, { sortKey }) => {
    let newDirection: 'asc' | 'desc' | null = 'asc';
    if (state.sortKey === sortKey) {
      if (state.sortDirection === 'asc') newDirection = 'desc';
      else if (state.sortDirection === 'desc') newDirection = null;
    }
    return {
      ...state,
      sortKey: newDirection ? sortKey : null,
      sortDirection: newDirection,
    };
  }),
  on(DashboardActions.clearSort, (state) => ({
    ...state,
    sortKey: null,
    sortDirection: null,
  })),

  // Set filtered rows
  on(DashboardActions.setFilteredRows, (state, { filteredRows }) => ({
    ...state,
    filteredRows,
  })),

  // Clear error
  on(DashboardActions.clearError, (state) => ({
    ...state,
    error: null,
  }))
);
